import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DailyBlockSchemaObject } from "../DailyBlockSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = "DAILYBLOCKREPORT";

export function DailyBlockReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [division, setDivision] = useState([]);
    const [field, setField] = useState([]);
    const [block, setBlock] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [dailyBlockReportDetails, setDailyBlockReportDetails] = useState({
        groupID: "0",
        estateID: "0",
        date: "",
        divisionID: "0",
        fieldID: "0",
        blockID: "0",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        date: "",
        division: "0",
        field: "0",
        block: "0"
    });

    const csvHeaders = [
        { label: "Reg No.", value: "regNumber" },
        { label: "Name", value: "supplierName" },
        { label: "Field", value: "fieldName" },
        { label: "Block", value: "blockName" },
        { label: "Session", value: "sessionName" },
        { label: "Quantity (Kg)", value: "quantity" }
    ];

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(DailyBlockSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["regNumber", "supplierName", "fieldName", "blockName",
    "sessionName", "quantity"];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [dailyBlockReportDetails.groupID])

    useEffect(() => {
        trackPromise(getDivisionForDropdown())
    }, [dailyBlockReportDetails.estateID]);

    useEffect(() => {
        trackPromise(getFieldForDropdown())
    }, [dailyBlockReportDetails.divisionID]);

    useEffect(() => {
        trackPromise(getBlocksForDropdown())
    }, [dailyBlockReportDetails.fieldID]);

    function handleGroupChange(target) {
        validateInputs(target);

        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            groupID: target.value,
            estateID: "0",
            date: "",
            divisionID: "0",
            fieldID: "0",
            blockID: "0"
        });
        clearTable();
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            estateID: target.value,
            date: "",
            divisionID: "0",
            fieldID: "0",
            blockID: "0"
        });
        clearTable();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            date: target.value
        });
        clearTable();
    }

    function handleChangeCommon(target) {
        validateInputs(target);

        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            [target.name]: target.value
        });
        clearTable();
    }

    function handleChangeDivision(target) {
        validateInputs(target);

        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            divisionID: target.value,
            fieldID: "0",
            blockID: "0"
        });
        clearTable();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyBlockSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYBLOCKREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(dailyBlockReportDetails.groupID);
        setEstates(data);
    }

    async function getDivisionForDropdown() {
        const data = await services.GetDivisionByEstateID(dailyBlockReportDetails.estateID);
        setDivision(data);
    }

    async function getFieldForDropdown() {
        const data = await services.GetFieldsByCollectionPoint(dailyBlockReportDetails.divisionID);
        setField(data);
    }

    async function getBlocksForDropdown() {
        const data = await services.GetBlocksByFieldID(dailyBlockReportDetails.fieldID);
        setBlock(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();

        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, dailyBlockReportDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getDailyBlockReportData(dailyBlockReportDetails);

        if (result.length > 0){
            const totalQuantity = result.reduce((totalQuantity, item) => totalQuantity = totalQuantity + item.quantity, 0)
            setTotalQuantity(totalQuantity);
        }

        setReportData(result);

        if (result.length != 0) {
            setIsTableHide(false);
            createDataTable();
            addSelectedSearchValues();
            setCsvData(result);
        }
    }

    function addSelectedSearchValues() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[dailyBlockReportDetails.groupID],
            estate: estates[dailyBlockReportDetails.estateID],
            division: division[dailyBlockReportDetails.divisionID],
            field: field[dailyBlockReportDetails.fieldID],
            date: dailyBlockReportDetails.date,
            block: block[dailyBlockReportDetails.blockID]
        })
    }

    function destroyDataTable() {
        $("#dailyBlockReport").DataTable().destroy();
    }

    function createDataTable() {
        $('#dailyBlockReport').DataTable();
    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Block Report',
            fileName: 'DailyBlockReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            regNumber: "Total",
            quantity: totalQuantity
        }
        var newRow2 = {
            regNumber: "Group :" + groups[dailyBlockReportDetails.groupID],
            supplierName: "Operation Entity : " + estates[dailyBlockReportDetails.estateID],
            fieldName: "Division : " + division[dailyBlockReportDetails.divisionID]
        }
        var newRow3 = {
            regNumber: "Field : " + field[dailyBlockReportDetails.fieldID],
            supplierName: "Block : " + block[dailyBlockReportDetails.blockID],
            fieldName: "Date : " + dailyBlockReportDetails.date
        }
        copyOfCsv.push(newRow1)
        copyOfCsv.push({}, {}, newRow2)
        copyOfCsv.push(newRow3)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setDailyBlockReportDetails({
            ...dailyBlockReportDetails,
            date: "",
            division: "0",
            field: "0",
            block: "0"
        });
        setIsTableHide(true);
        setErrors("");
    }

    function clearTable() {
        setIsTableHide(true);
        setReportData([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Daily Block Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyBlockReportDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyBlockReportDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="divisionID">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={dailyBlockReportDetails.divisionID}
                                            onChange={(e) => handleChangeDivision(e.target)}
                                        >
                                            <MenuItem value="0">--All Divisions--</MenuItem>
                                            {generateDropDownMenu(division)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    </div>
                                <div className="row"> 
                                    <div className="col-md">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="fieldID"
                                            id="fieldID"
                                            name="fieldID"
                                            value={dailyBlockReportDetails.fieldID}
                                            onChange={(e) => handleChangeCommon(e.target)}
                                        >
                                            <MenuItem value="0">--All Fields--</MenuItem>
                                            {generateDropDownMenu(field)}
                                        </Select>
                                        {errors["fieldID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>)}
                                    </div>    
                                <div className="col-md">
                                        <InputLabel shrink id="blockID">Block</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="blockID"
                                            id="blockID"
                                            name="blockID"
                                            value={dailyBlockReportDetails.blockID}
                                            onChange={(e) => handleChangeCommon(e.target)}
                                        >
                                            <MenuItem value="0">--All Blocks--</MenuItem>
                                            {generateDropDownMenu(block)}
                                        </Select>
                                        {errors["blockID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["blockID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, dailyBlockReportDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            <div className="card p-2">
                                                <div className="table-responsive row-top-gap">
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left" style={{ fontWeight: "bold"  }}>
                                                                        Reg No.
                                                                    </TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                        Name
                                                                    </TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                        Field
                                                                    </TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                        Block
                                                                    </TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                        Session
                                                                    </TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                    Quantity (Kg)
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reportData.map((row) => (
                                                                    <TableRow key={row.employeeCode}>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.regNumber}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.supplierName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.fieldName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.blockName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.sessionName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" align="right">
                                                                            {row.quantity}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan={5} align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalQuantity}</TableCell>
                                                                </TableRow>

                                                            </TableHead>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Daily Block Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} reportData={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues}
                                            totalQuantity={totalQuantity} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
